import React, { PropsWithChildren } from 'react';
import { FaCirclePlay, FaLink, FaXmark } from 'react-icons/fa6';
import { FcComboChart, FcSettings } from 'react-icons/fc';
import { GoComment, GoDownload } from 'react-icons/go';
import { HiDocumentAdd, HiOutlineDocumentDuplicate } from 'react-icons/hi';
import { IoMdTime } from 'react-icons/io';
import { IoShareSocialOutline } from 'react-icons/io5';
import {
  MdCheck,
  MdDelete,
  MdEdit,
  MdHistory,
  MdRemoveRedEye,
  MdOutlineLinkOff,
} from 'react-icons/md';
import { Link as ReactLink, To } from 'react-router-dom';

type ButtonProps = {
  onClick?: () => void;
};

type LinkProps = {
  path: To;
};

const Wrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className="flex flex-row gap-1">{children}</div>;
};

const Show: React.FC<LinkProps> = ({ path }) => {
  return (
    <ReactLink className="my-auto text-gray-500" to={path}>
      <MdRemoveRedEye size={17} />
    </ReactLink>
  );
};

const Edit: React.FC<LinkProps> = ({ path }) => {
  return (
    <ReactLink className="text-blue-500" to={path}>
      <MdEdit size={17} />
    </ReactLink>
  );
};

const EditButton: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="text-blue-500" onClick={onClick}>
      <MdEdit size={17} />
    </button>
  );
};

const Delete: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="text-red-500" onClick={onClick}>
      <MdDelete size={17} />
    </button>
  );
};

const Unlink: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="text-red-500" onClick={onClick}>
      <MdOutlineLinkOff size={17} />
    </button>
  );
};

const Comment: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5 text-gray-500" onClick={onClick}>
      <GoComment size={17} />
    </button>
  );
};

const Download: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5 text-gray-500" onClick={onClick}>
      <GoDownload size={17} />
    </button>
  );
};

const Run: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5 text-green-500" onClick={onClick}>
      <FaCirclePlay size={21} />
    </button>
  );
};

const Chart: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5 text-gray-500" onClick={onClick}>
      <FcComboChart size={21} />
    </button>
  );
};

const Time: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5" onClick={onClick}>
      <IoMdTime size={21} />
    </button>
  );
};

const Clone: React.FC<LinkProps> = ({ path }) => {
  return (
    <ReactLink className="flex mx-0.5 " to={path}>
      <HiOutlineDocumentDuplicate size={17} /> Clone
    </ReactLink>
  );
};

const Share: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5" onClick={onClick}>
      <IoShareSocialOutline size={17} />
    </button>
  );
};

const Add: React.FC<LinkProps> = ({ path }) => {
  return (
    <ReactLink className="mx-0.5" to={path}>
      <HiDocumentAdd size={17} />
    </ReactLink>
  );
};

const Close: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5 text-red-600" onClick={onClick}>
      <FaXmark size={20} />
    </button>
  );
};

const Settings: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5 text-gray-500" onClick={onClick}>
      <FcSettings size={21} />
    </button>
  );
};

const Check: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5 text-green-500" onClick={onClick}>
      <MdCheck size={17} />
    </button>
  );
};

const History: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5 text-gray-500" onClick={onClick}>
      <MdHistory />
    </button>
  );
};

const Link: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <button type="button" className="mx-0.5 text-gray-500" onClick={onClick}>
      <FaLink />
    </button>
  );
};

export const ActionButton = {
  Wrapper,
  Show,
  Edit,
  EditButton,
  Delete,
  Comment,
  Run,
  Chart,
  Time,
  Clone,
  Share,
  Add,
  Settings,
  Check,
  Close,
  Download,
  Unlink,
  History,
  Link,
};
